import rung from "rung/src/rung";
//import seed from "rung/src/seed";
import Queue from "peculiar/queue";
import Directions from "./directions";
import { fillConnectedAreas, getAdjacentCells, jaggedFloodFill } from "./flow";
import { createPathfinder } from "./pathfinder";
import Tiles from "../tiles";

const rng = rung();

// function removeRandom(array) {
//   const index = rng.integer(array.length);
//   const removedItem = array.splice(index, 1);
//   return removedItem[0];
// }

// function jaggedFloodFill(grid, origin, max, cell) {
//   const visited = new Set();
//   const area = [];
//   const frontier = [];
//
//   visited.add(origin);
//   area.push(origin);
//   frontier.push(origin);
//
//   while (frontier.length != 0) {
//     if (area.length >= max) return;
//
//     const currentCell = removeRandom(frontier);
//
//     for (let nextCell of getAdjacentCells(grid[0].length, grid.length, currentCell.x, currentCell.y)) {
//       if (visited.has(nextCell)) continue;
//
//       visited.add(nextCell);
//
//       if (grid[nextCell.y][nextCell.x] != cell) {
//         frontier.push(nextCell);
//         area.push(nextCell);
//         grid[nextCell.y][nextCell.x] = cell;
//       }
//     }
//   }
//
//   return;
// }

const TerrainCell = {
  CHASM: 0,
  ROCK: 1,
  CAVE: 2,
  ENTRANCE: 3,
  EXIT: 4
}

function generateChasm(width, height, config) {
  const grid = [];

  for (let y=0; y < height; y++) {
    grid[y] = [];
    for (let x=0; x < width; x++) {
      grid[y][x] = TerrainCell.ROCK;
    }
  }

  const origin = {
    x: width / 2,
    y: height / 2
  }

  jaggedFloodFill(
    grid,
    origin,
    config.chasmSize,
    TerrainCell.CHASM
  );

  return grid;
}

const defaultConfig = {
  chasmSize: 340,
  minCaveSteps: 900,
  maxCaveSteps: 2900
}

function randomCornerCell(width, height) {
  switch(rng.integer(1, 5)) {
    case 1:
      return {
        x: rng.integer(2, width / 4),
        y: rng.integer(2, height / 4)
      };
    case 2:
      return {
        x: rng.integer(width - (width / 4), width),
        y: rng.integer(2, height / 4)
      };
    case 3:
      return {
        x: rng.integer(2, width / 4),
        y: rng.integer(height - (height / 4), height)
      };
    case 4:
      return {
        x: rng.integer(width - (width / 4), width),
        y: rng.integer(height - (height / 4), height)
      };
  }
}

function findOpenTile(tiles, type) {
  let result = false
  const xMax = tiles[0].length;
  const yMax = tiles.length;

  while (!result) {
    const cx = rng.integer(0, xMax);
    const cy = rng.integer(0, yMax);

    if (tiles[cy][cx] == type) {
      result = { x: cx, y: cy };
    }
  }

  return result;
}

// function fillConnectedAreas(terrain, cell) {
//   const visited = new Set();
//   const areas = [];
//
//   for (let y = 0; y < terrain.length; y++) {
//     for (let x = 0; x < terrain[0].length; x++) {
//       if (terrain[y][x] != cell || visited.has(`${x},${y}`)) continue;
//
//       const area = [];
//       const frontier = new Queue();
//       frontier.push({x, y});
//
//       while (!frontier.isEmpty()) {
//         const currentCell = frontier.poll();
//         area.push(currentCell);
//
//         for (const nextCell of getAdjacentCells(terrain[0].length, terrain.length, currentCell.x, currentCell.y)) {
//           const label = `${nextCell.x},${nextCell.y}`;
//           if (visited.has(label)) continue;
//           visited.add(label);
//
//           if (terrain[nextCell.y][nextCell.x] == cell) {
//             frontier.push(nextCell);
//             area.push(nextCell);
//           }
//         }
//       }
//
//       areas.push(area);
//     }
//   }
//
//   return areas;
// }

const CarbonateCaves = {
  cave: Tiles.CarbonateCave,
  rocks: [
    Tiles.CarbonateRock1,
    Tiles.CarbonateRock2,
    Tiles.CarbonateRock3,
    Tiles.CarbonateRock4
  ],
  entrance: Tiles.CarbonateEntrance,
  exit: Tiles.CarbonateExit
}

const SlateCaves = {
  cave: Tiles.SlateCave,
  rocks: [
    Tiles.SlateRock1,
    Tiles.SlateRock2,
    Tiles.SlateRock3,
    Tiles.SlateRock4
  ],
  entrance: Tiles.SlateEntrance,
  exit: Tiles.SlateExit
}

const LimestoneCaves = {
  cave: Tiles.LimestoneCave,
  rocks: [
    Tiles.LimestoneRock1,
    Tiles.LimestoneRock2,
    Tiles.LimestoneRock3,
    Tiles.LimestoneRock4
  ],
  entrance: Tiles.LimestoneEntrance,
  exit: Tiles.LimestoneExit
}

const CaveTypes = [
  CarbonateCaves,
  SlateCaves,
  LimestoneCaves
]

function randomCaveMorphology() {
  return CaveTypes[rng.integer(0, 3)];
}

function generateCaves(configuration) {
  const config = { ...defaultConfig, ...configuration };
  const width = config.width;
  const height = config.height;
  const terrain = generateChasm(width, height, config);
  const features = {};

  if (config.spiderCaves) {
    // Carve spider caves
    const node = randomCornerCell(width, height);
    terrain[node.y][node.x] = TerrainCell.CAVE;
    terrain[node.y+1][node.x] = TerrainCell.CAVE;
    terrain[node.y-1][node.x] = TerrainCell.CAVE;
    terrain[node.y][node.x+1] = TerrainCell.CAVE;
    terrain[node.y][node.x-1] = TerrainCell.CAVE;
    features.spiderCave = node;
  }

  let iterations = 0;

  while (iterations < rng.integer(config.minCaveSteps, config.maxCaveSteps)) {
    const digger = {
      x: rng.integer(0, width - 2),
      y: rng.integer(0, height - 2)
    }

    let digging = true;

    while (digging) {
      const walk = Directions.CARDINAL[rng.integer(0, 4)];
      const candidateX = Math.max(0, Math.min(digger.x + walk.x, width - 2));
      const candidateY = Math.max(0, Math.min(digger.y + walk.y, height - 2));

      if (terrain[candidateY][candidateX] != TerrainCell.ROCK) {
        if (terrain[digger.y][digger.x] == TerrainCell.ROCK) {
          terrain[digger.y][digger.x] = TerrainCell.CAVE;
        }
        digging = false;
      } else {
        digger.x = candidateX;
        digger.y = candidateY;
      }
    }

    iterations++;
  }

  // Flood fill again to detect open cave areas
  const areas = fillConnectedAreas(terrain, TerrainCell.CAVE);

  // Sort the areas first so that we can fill small gaps before doing a larger pass.
  areas.sort((a, b) => a.length - b.length);

  const loopholes = [];
  const caves = [];

  for (const area of areas) {
    // Check for unconnected cave pockets adjacent to the main chasm.
    // Instead of filling all of these in with rock, we can use them to place
    // kobold archers or spitting vines.
    if (area.length == 1) {
      let fillGap = true;

      for (const dir of Directions.CARDINAL) {
        if (terrain[area[0].y + dir.y][area[0].x + dir.x] == TerrainCell.CHASM) {
          loopholes.push(area[0]);
          fillGap = false;
          break;
        }
      }

      // Isolated pocket away from the main chasm so fill it with rock.
      if (fillGap) {
        terrain[area[0].y][area[0].x] = TerrainCell.ROCK;
      }

    } else {
      // Main cave areas that need to be joined.
      caves.push(area);
    }
  }

  features.loopholes = loopholes;

  // Ensure main cave areas are continuously navigable.
  for (let i = 0; i < caves.length - 1; i++) {

    // Callback to collect adjacent nodes from the terrain map
    const adjacentNodes = (x, y) => {
      const adjacent = [];
      for (const node of getAdjacentCells(width, height, x, y)) {
        adjacent.push(node);
      }
      return adjacent;
    }

    // TODO: document this in flatland
    const costHeuristic = (from, to) => (
      Math.abs(from.x - to.x) + Math.abs(from.y - to.y) * 1.01
    );

    // Wall tiles are more costly than floor tiles but can still be traversed
    // Tweak this to see what different kinds of pathways are possible.
    const traversalCost = (x, y) => {
      return (terrain[y][x] == TerrainCell.ROCK) ? 4 : 1;
    }

    // Can move through rock and caves but chasm is off limits
    const isTraversable = (x, y) => terrain[y][x] != TerrainCell.CHASM;

    // Configure an A* search to trace a path from source to target
    const search = createPathfinder(
      adjacentNodes,
      costHeuristic,
      traversalCost,
      isTraversable
    );

    const source = caves[i][rng.integer(0, caves[i].length)];
    const target = caves[i + 1][rng.integer(0, caves[i + 1].length)];

    const path = search(source, target);

    // Fill the entire path in with cave tiles
    for (const connectingCell of path) {
      terrain[connectingCell.y][connectingCell.x] = TerrainCell.CAVE;
    }
  }

  const entrance = findOpenTile(terrain, TerrainCell.CAVE);

  const exit = (config.spiderCaves) ? features.spiderCave : findOpenTile(terrain, TerrainCell.CAVE);

  terrain[entrance.y][entrance.x] = TerrainCell.ENTRANCE;
  terrain[exit.y][exit.x] = TerrainCell.EXIT;

  const tiles = [];

  const morphology = randomCaveMorphology();

  for (let y=0; y < height; y++) {
    tiles[y] = terrain[y].map(cell => {
      switch (cell) {
        case TerrainCell.CHASM: return Tiles.Chasm;
        case TerrainCell.ROCK: return morphology.rocks[rng.integer(0,3)];
        case TerrainCell.CAVE: return morphology.cave;
        case TerrainCell.ENTRANCE: return morphology.entrance;
        case TerrainCell.EXIT: return morphology.exit;
      }
    });
  }

  return {
    tiles,
    portals: {
      entrance,
      exit
    },
    features
  };
}

export {
  generateCaves
}
